import styles from "./Input.module.css";

export default function Input({ value, onChange, onClick, buttonName }) {
    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            onClick(); // Call the button click handler when Enter is pressed
        }
    };

    return (
        <div className={styles.MMAIwrapper}>
            <input
                className={styles.MMAItext}
                placeholder="Ask your question here..."
                value={value}
                onChange={onChange}
                onKeyDown={handleKeyDown} // Handle Enter key press
            />
            <button className={styles.MMAIbtn} onClick={onClick}>
                {buttonName}
            </button>
        </div>
    );
}
